import { WalletDetailsProps, useWalletDetails } from '../providers/WalletDetailsProvider';

function useWallet(): WalletDetailsProps {
  const { walletDetails } = useWalletDetails();

  return walletDetails;
}

export default useWallet;
